import { render, staticRenderFns } from "./ModalUsuariosEleicao.vue?vue&type=template&id=55db34ca&scoped=true"
import script from "./ModalUsuariosEleicao.vue?vue&type=script&lang=js"
export * from "./ModalUsuariosEleicao.vue?vue&type=script&lang=js"
import style0 from "./ModalUsuariosEleicao.vue?vue&type=style&index=0&id=55db34ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55db34ca",
  null
  
)

export default component.exports